export function blockInteraction(state) {
  state.canInteract = false;
}
export function allowInteraction(state) {
  state.canInteract = true;
}
export function updateCurrentPosition(state, payload) {
  state.position = payload;
} // Flush all pages

export function flushPages(state) {
  state.pages = [];
} // Add pages to array indexed by codename

export function addPage(state, payload) {
  state.pages[payload.codename] = payload;
} // Update a page by codename

export function updatePage(state, _ref) {
  var codename = _ref.codename,
      payload = _ref.payload;
  state.pages[codename] = payload;
}
export function setSavedPosition(state, payload) {
  state.savedPosition = payload;
}